import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Fab, TextField, Modal } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import EditStation from "./EditStation";
import Box from "@mui/material/Box";
import DeleteStation from "./DeleteStation";
import { addCommas } from "@persian-tools/persian-tools";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	maxWidth: 800,
	width: "90%",
	bgcolor: "background.paper",
	border: "2px solid #000",
	boxShadow: 24,
	p: 4,
	mx: "auto",
};

const Process = (props) => {
	const {
		idP,
		stationNameP,
		oneJaw1To7P,
		twoJaw1To7P,
		oneJaw7To14P,
		twoJaw7To14P,
		twoJaw14To21P,
		twoJaw21To28P,
		oneJawFullP,
		twoJawFullP,
	} = props;

	const [open1, setOpen1] = useState(false);
	const handleOpen1 = () => setOpen1(true);
	const handleClose1 = () => setOpen1(false);
	const [open2, setOpen2] = useState(false);
	const handleOpen2 = () => setOpen2(true);
	const handleClose2 = () => setOpen2(false);

	return (
		<React.Fragment>
			<Modal open={open1} onClose={handleClose1}>
				<Box sx={style}>
					<EditStation
						id={idP}
						stationName={stationNameP}
						oneJaw1To7={oneJaw1To7P}
						twoJaw1To7={twoJaw1To7P}
						oneJaw7To14={oneJaw7To14P}
						twoJaw7To14={twoJaw7To14P}
						twoJaw14To21={twoJaw14To21P}
						twoJaw21To28={twoJaw21To28P}
						oneJawFull={oneJawFullP}
						twoJawFull={twoJawFullP}
						close={handleClose1}
						open={open1}
					/>
				</Box>
			</Modal>
			<Modal open={open2} onClose={handleClose2}>
				<Box sx={style}>
					<DeleteStation id={idP} close={handleClose2} />
				</Box>
			</Modal>

			<Grid md={1} xs={6}>
				<Fab color="secondary" onClick={handleOpen1}>
					<EditIcon />
				</Fab>
			</Grid>

			<Grid md={1} xs={6}>
				<Fab color="error" onClick={handleOpen2}>
					<DeleteIcon />
				</Fab>
			</Grid>
			<Grid md={10} xs={12}>
				<TextField
					label="مرحله کاری"
					variant="outlined"
					value={stationNameP}
					fullWidth
					inputProps={{ readOnly: true }}
				/>
			</Grid>
			<Grid md={3} xs={6}>
				<TextField
					label="1 تا 7 واحد، یک فک"
					variant="standard"
					value={addCommas(Number(oneJaw1To7P))}
					fullWidth
					inputProps={{ readOnly: true }}
				/>
			</Grid>
			<Grid md={3} xs={6}>
				<TextField
					label="1 تا 7 واحد، دو فک"
					variant="standard"
					value={addCommas(Number(twoJaw1To7P))}
					fullWidth
					inputProps={{ readOnly: true }}
				/>
			</Grid>
			<Grid md={3} xs={6}>
				<TextField
					label="7 تا 14 واحد، یک فک"
					variant="standard"
					value={addCommas(Number(oneJaw7To14P))}
					fullWidth
					inputProps={{ readOnly: true }}
				/>
			</Grid>
			<Grid md={3} xs={6}>
				<TextField
					label="7 تا 14 واحد، دو فک"
					variant="standard"
					value={addCommas(Number(twoJaw7To14P))}
					fullWidth
					inputProps={{ readOnly: true }}
				/>
			</Grid>
			<Grid md={3} xs={6}>
				<TextField
					label="14 تا 21 واحد ، دو فک"
					variant="standard"
					value={addCommas(Number(twoJaw14To21P))}
					fullWidth
					inputProps={{ readOnly: true }}
				/>
			</Grid>
			<Grid md={3} xs={6}>
				<TextField
					label="21 تا 28 واحد ، دو فک"
					variant="standard"
					value={addCommas(Number(twoJaw21To28P))}
					fullWidth
					inputProps={{ readOnly: true }}
				/>
			</Grid>
			<Grid md={3} xs={6}>
				<TextField
					label="یک فک کامل"
					variant="standard"
					value={addCommas(Number(oneJawFullP))}
					fullWidth
					inputProps={{ readOnly: true }}
				/>
			</Grid>
			<Grid md={3} xs={6}>
				<TextField
					label="دو فک کامل"
					variant="standard"
					value={addCommas(Number(twoJawFullP))}
					fullWidth
					inputProps={{ readOnly: true }}
				/>
			</Grid>
		</React.Fragment>
	);
};

export default Process;
